import React from "react";
import { Div } from "components/Base";
import { connect } from "react-redux";
import { getters, actions } from "Portal/ApplicationForm/model";
import { getUserName } from "Portal/ApplicationForm/selectors";

const decorate = connect(
  state => ({
    isLoggedIn: getters.isLoggedIn(state),
    userName: getUserName(state)
  }),
  {
    handleLogout: actions.handleLogout
  }
);

const WelcomeLoginSection = ({
  isLoggedIn,
  handlers,
  handleLogout,
  userName
}) =>
  isLoggedIn ? (
    <Div display="column">
      <Div fw={3} color="black">
        You are logged in as {userName}.
      </Div>
      <Div fs={1}>
        Not you?{" "}
        <span
          onClick={() => {
            handlers.setShowAlert(false);
            handleLogout();
          }}
          style={{
            textDecoration: "underline",
            cursor: "pointer"
          }}
        >
          Log out
        </span>
        .
      </Div>
    </Div>
  ) : null;

export default decorate(WelcomeLoginSection);
